module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("Loading")]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "center-align"
  }, [_c('h5', {
    staticClass: "bold title"
  }, [_vm._v("Enter the quantity of parts desired on the build plate")]), _vm._v(" "), _c('table', {
    staticClass: "highlight"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.filesNested), function(file, pathKey) {
    return _c('tr', {
      key: file.id
    }, [_c('td', [_c('i', {
      staticClass: "material-icons a3d color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeFile(file)
        }
      }
    }, [_vm._v("clear")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "filename"
    }, [_vm._v(_vm._s(file.name))])]), _vm._v(" "), _c('td', [_c('input', {
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": file.quantity
      },
      on: {
        "input": function($event) {
          return _vm.updateQuantity(pathKey, $event)
        }
      }
    }), _vm._v(" "), (file.quantity < 1) ? _c('div', {
      staticClass: "error"
    }, [_vm._v("Quantity should be greater than 0")]) : _vm._e()])])
  }), 0)]), _vm._v(" "), (_vm.submitting) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-buttons"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a3d btn",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.goNext()
      }
    }
  }, [_vm._v("Next")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader-wrapper small active"
  }, [_c('div', {
    staticClass: "spinner-layer"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "remove-file"
  }), _vm._v(" "), _c('th', [_vm._v("File")]), _vm._v(" "), _c('th', {
    staticClass: "quantity"
  }, [_vm._v("Desired Quantity")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-414352eb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-414352eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nested.vue
// module id = 483
// module chunks = 1